import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Optional, Output, TemplateRef, ViewChild } from '@angular/core';
import { AutoHandle, ExpireOperation } from "../time-limit-control.entity";
import { MessagerService } from '@farris/ui-messager';
import { ProcessDesignerUIState } from '../../../app/process-designer.uistate';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-auto-handle-operation',
  templateUrl: './auto-handle-operation.component.html',
  styleUrls: ['./auto-handle-operation.component.css'],
  providers: [
     WfLocalePipe,
  ]
})
export class AutoHandleOperationComponent implements OnInit {

  @ViewChild('footer') footer: TemplateRef<any>;
  @Input()
  set value(info: AutoHandle) {
    this.operation = Object.assign({}, info);
    if (this.operation.autoHandleType === undefined) {
      const autoHandle = new AutoHandle(this.autoHandleType[0].value, this.localePipe);
      this.operation.autoHandleType = autoHandle.autoHandleType;
      this.operation.message = autoHandle.message;
    }
  }

  get value() {
    return this.operation;
  }

  placeholder = '';
  operation: AutoHandle = new AutoHandle('Pass', this.localePipe);
  @Output() submitEmitter = new EventEmitter<ExpireOperation>();
  @Output() closeEmitter = new EventEmitter<any>();

  autoHandleType = [
    // { value: 'autoPass', text: '自动通过' },
    // { value: 'autoBack', text: '自动驳回' }
  ];

  constructor(
    private message: MessagerService,
    public uiState: ProcessDesignerUIState,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
    for(const item of this.uiState.propertyData.ApprovalItems) {
      this.autoHandleType.push({value: item.Value,text: item.Text});
    }
  }

  ngOnInit() {
  }

  clickOK() {
    if (this.validator()) {
      this.submitEmitter.emit(this.operation);
    }
  }

  clickCancel() {
    this.closeEmitter.emit();
  }

  private validator(): boolean {
    if (!this.operation.message) {
      this.message.info(this.localePipe.transform('component.sendMessageOperation.opinionsNotEmpty'));
      return false;
    }
    if (!this.operation.autoHandleType) {
      this.message.info(this.localePipe.transform('component.sendMessageOperation.processingNotEmpty'));
      return false;
    }
    return true;
  }

}
